import React from 'react';
import {
    View,
    Text,
    TouchableOpacity,
    TextInput,
    Alert,
    FlatList,
    Image,
    ImageBackground,
    TextProps, ViewProps, ScrollView, TouchableWithoutFeedback
} from 'react-native';
import { connect } from 'react-redux';
import IAppState from "../Models/App/IAppState";

import {AnyAction} from "redux";


import {StackNavigationProp} from "@react-navigation/stack";
import { RouteProp } from '@react-navigation/native';
import AppText from "./AppText";
import HideableView from "./HideableView";
import SubClientItem from "./SubClientItem";
import IClient from "../Models/Client/IClient";
import ISubClient from "../Models/Client/ISubClient";
import HttpRequest from "../utils/HttpRequest";
import AlertModal from "./AlertModal";
import AppButton from "./AppButton";
import IOrder from "../Models/IOrder";
import SubOrderItem from "./SubOrderItem";
import ISubOrder from "../Models/Courier/ISubOrder";
import ConfirmionModal from "./ConfirmionModal";


type ProjectsScreenNavigationProp = StackNavigationProp< any, 'Projects'>;
interface IProps {
    order:IOrder;
    onLongPress:Function
    removeSubOrderCallBack:Function
}
interface IState {
    isInfoOpened:boolean;
    isAddOpened:boolean;

    isErrorAlert:boolean;
    showAlert:boolean;
    alertText:string;
    confirmText:string;
    showConfirm:boolean;
    orderToRemove?:ISubOrder
}

export default class OpenedOrderItem extends React.Component<IProps & ViewProps> {

    state:IState={
        isInfoOpened:false,
        isAddOpened:false,

        isErrorAlert:false,
        showAlert:false,
        alertText:'',
        confirmText:'',
        showConfirm:false

    }
    componentDidMount() {

    }
    selectSubOrderToRemove(subOrder:ISubOrder){
        let text='האם את רוצה למחוק את תת הזמנה של '+subOrder.SubClient?.name+ "?";
        this.setState({orderToRemove:subOrder,showConfirm:true,confirmText:text})
    }
    removeSubOrder(){
        let orderToRemove=this.state.orderToRemove;
        this.setState({showConfirm:false})
        if(orderToRemove && orderToRemove.id){
            let orderId=orderToRemove.id;
            this.props.removeSubOrderCallBack(this.props.order.id,orderId)
            HttpRequest('orders/subOrder','DELETE',{id:orderId}).then((result)=>{

            }).catch(e=>{

            })
        }
    }
    render() {
        return(
            <View style={{width:'100%',alignItems:'center'}}>
                <TouchableWithoutFeedback onLongPress={()=>this.props.onLongPress(this.props.order)} >
                    <View style={{flexDirection:'row',borderBottomColor:'grey',borderWidth:1,justifyContent:'center',alignItems:'center',paddingLeft:15,paddingRight:15,paddingBottom:10,paddingTop:10}}>
                        <View style={{flex:0.23,alignItems:'flex-start'}}>
                            <AppText style={{color:'black',fontSize:12,fontWeight:'700',textAlign:'left'}}>{this.props.order.Client?.businessName}</AppText>
                        </View>
                        <View style={{flex:0.32,alignItems:'flex-start'}}>
                            <AppText style={{color:'black',fontSize:12,textAlign:'left'}}>{this.props.order.Client?.address}</AppText>
                        </View>
                        <View style={{flex:0.23,alignItems:'flex-start'}}>
                            <AppText style={{color:'black',fontSize:12,textAlign:'left'}}>{this.props.order.Client?.phone}</AppText>
                        </View>
                        <View style={{flex:0.22,alignItems:'flex-end',}}>
                            <TouchableOpacity style={{width:70,height:20,backgroundColor:this.state.isInfoOpened?'#01B271':'#019FB2',justifyContent:'center',alignItems:'center',borderRadius:25}} onPress={()=>this.setState({isInfoOpened:!this.state.isInfoOpened})}>
                                <AppText style={{color:'#fff',fontWeight:'500',fontSize:12}}>{!this.state.isInfoOpened?'פתח':'סגור'}</AppText>
                            </TouchableOpacity>

                        </View>
                    </View>
                </TouchableWithoutFeedback>
                <HideableView hidden={!this.state.isInfoOpened} style={{width:'100%'}}>

                    <FlatList
                        data={this.props.order.SubOrders}

                        renderItem={({ item }) =><SubOrderItem order={this.props.order} isOpened={true} subOrder={item} removeCallBack={(subOrder:ISubOrder)=>this.selectSubOrderToRemove(subOrder)}/> }
                    />
                    <ConfirmionModal confirmCallBack={()=>this.removeSubOrder()} closeCallBack={()=>this.setState({showConfirm:false})} text={this.state.confirmText} show={this.state.showConfirm}/>

                </HideableView>

            </View>
        );
    }
}

